import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';

export const WizardProgress = memo(({ current, length }) => {
  const { styles } = useStyle();
  return (
    <View style={styles.container}>
      {Array(length)
        .fill(0)
        .map((item, index) => {
          const selected = index === current;
          return (
            <View
              style={[styles.indicator, selected && styles.indicatorSelected]}
            />
          );
        })}
    </View>
  );
});

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    flexDirection: 'row',
    gap: 5,
  },
  indicator: {
    width: 8,
    height: 8,
    borderRadius: 100,
    backgroundColor: colors.gray22,
  },
  indicatorSelected: {
    width: 20,
    backgroundColor: colors.red1,
  },
}));
